import { IconDeviceDesktop, IconMoon, IconSun } from "@tabler/icons-react";
import { useResolvedTheme, useThemeStore } from "@/lib/theme-store";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "../DropdownMenu";

/**
 * Botón del header que abre un menú Claro/Sistema/Oscuro · reemplaza
 * `useMantineColorScheme`/`useComputedColorScheme` por `theme-store.ts`
 * (Etapa 0). El ícono refleja el tema RESUELTO (no el modo elegido), así
 * "Sistema" muestra sol u luna según la preferencia real del SO — mismo
 * comportamiento que el original.
 */
export function ThemeToggle() {
  const setMode = useThemeStore((s) => s.setMode);
  const resolved = useResolvedTheme();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label="Cambiar tema"
          className="flex size-8 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted"
        >
          {resolved === "dark" ? <IconMoon size={15} /> : <IconSun size={15} />}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-45">
        <DropdownMenuLabel>Apariencia</DropdownMenuLabel>
        <DropdownMenuItem onClick={() => setMode("light")}>
          <IconSun size={14} className="mr-1" /> Claro
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setMode("system")}>
          <IconDeviceDesktop size={14} className="mr-1" /> Sistema
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setMode("dark")}>
          <IconMoon size={14} className="mr-1" /> Oscuro
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
